import { SC_Input } from "../../input/SC_Input";

export class SC_CableClip {
	public static nVPE: number = 50;
	public static sVariable: string = "CABLECLIPPA";
	public static determineAmount(): number {
		return Math.ceil(SC_Input.iModulCount / this.nVPE);
	}
}